import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import AuthLayout from "@/layouts/auth-layout"
import { newAdminSessionPath } from "@/routes"

interface SentProps {
  email: string
}

export default function AdminPasswordResetSent({ email }: SentProps) {
  return (
    <AuthLayout title="" description="">
      <Head title="Check your email" />
      <div className="flex w-full flex-col gap-6">
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Check your email</CardTitle>
            <CardDescription>
              We sent password reset instructions to <strong>{email}</strong>
            </CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center">
            <Button
              variant="outline"
              asChild
              className="flex items-center gap-2"
            >
              <Link href={newAdminSessionPath()}>
                <ArrowLeft className="h-4 w-4" />
                Back to login
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  )
}
